import { constructionEquipment, logisticsAsset, retailExhibition } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: 'Trong kỷ nguyên số hóa, doanh nghiệp không chỉ thu hút khách hàng qua mạng mà còn muốn tương tác hiệu quả ngay tại vị trí thực tế của họ. Geofencing – hay hàng rào địa lý ảo – là công nghệ giúp doanh nghiệp gửi thông điệp, ưu đãi tức thì khi khách hàng bước vào, ra hoặc di chuyển trong khu vực địa lý nhất định. Bài viết này sẽ giải thích rõ Geofencing là gì? Có thể mang lại lợi ích gì cho doanh nghiệp.',
  keywords: 'geofencing, geofencing là gì, rtls, hàng rào địa lý, định vị vị trí',
  ogSite: 'Geofencing là gì? Có thể mang lại lợi ích gì cho doanh nghiệp?',
  title: 'Geofencing là gì? Có thể mang lại lợi ích gì cho doanh nghiệp?',
  ogUrl: 'https://orbro.io/vi/blog/geofencing-la-gi',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_G8QfFC5Uu90Qtg9sFFOG8gXubP_dgWr28njM7WDVCYpBSr3Zd7IUBwYLAViu2b_Lw2K3eHaYA3djmCq9nOr7qpL_MLvzGa0FndEZ7W3ZmgPUMEDcBWuwo0mg2P05SklsGtZil_2mBYF9aCMaCPKBT_CYUi2T1EksSqElaTr5bKvIDTNaFy3KK33YjR2VfQDgnhaKUiKUMDt3gp_sZ4hyebm54tSgDbyjlKxwKhm116TYjGtrVz9HsMP1ITkA6eGCosNsK0PjQKzYKJT3N3otHH7ZF6orZewAjNpS5FnsWdnIiCE53963FvWvFhzKK_MfNIY--4kP0kQuNehHkflI9X_zobNOAJOGY4yOdVS2zHe5XGXnOEMi20iUAUQbv6x0akSrqZJ3SpEqD2G1Bc7EB3_LM7yGM6c-Pan0y9RkDJtpXOpXTmDPzsqW2Rp_WjB8EY3XawdbCmh7tsH80rzNWJCfD4xJnmTxydT974YEahIwDZDIR_bG8h0fRErhuW4RRePdfScHinHJ2ty8p3v4rUPF6bNIq_SCnCAxf1R5_eFYeZSH8E6JQ15Hg9vn7MO1lLp2LMzPrwlddsOPfkUb-zbBmQlDBBhbQcB_YnhZaje72Ge_i3Yls_eaiZNyg1eh0TtUX69HzERRxw3gL5d41e6hGm3IQC92GDxRdK6xqPYiSTAtVMBnir8DFu6jzoxP4nr8JKoD1IEec3H1II2AxaXnXGMiyTMpuxewceQGFgsEWq5hqdi04oFoOVJt3bCSyMDYruP_8o91ORrEQ9IyaJKl7__Qtdozj_5J_-IY0kaByELZ_3QQF2HAWJbHzxSKW7zpcSqG5RBK-uPmwGTh2Z7U3wxckRCa_Ts23W-r0OCwmmWG29YMZz-ajzuas_oz_AQ6yHozeBaqalMz7arpEe5Hm95VvrISTe_j15zFp5ZeaDTuyafk_EA8oN0qewQnrzcsoLzBt5YDZ77LOLzm7_EHBetWxAkowOIIQHOQj3E5wpFIUEQA0X80ukJOxebaCyNwNqyBIDHVYUn36O0H3OnimiODn3jC7Hmnt-BvL-eXWIR8TWPrsvqBaWautEFz9WR6_R2wMgSZX34cHLqbKTME-3TxqvW1t76CJz_aio4wtqbgxl1uYwM79mxsTevZvKN3frUWssR5YPws3GKurM3i5wgY-j0EHJ8oj1W1Noq0pDInJxvJGe7Sjstl3f4Xianh49qE0uyBiEzFIUlEJs9KiBMZkVCAR9d0nmtvUW0Z4NztO7xTcOACchCsqQWIm_QbGGpOe6p_p1ozPj6QqClBDqHOgYPiwZVJeGpMevnOa1F3Gi5mdUJyUVbPnMG-HlgGXBrZh-AyBgZUqwCR04l-5utVHDaTK1frGJtnSQhvXGy9qVRrNb6itaRuDcWAJWGjXWD9OQqHQQfCSnI_bpuXgHO_zw1vjtPtQVi7GBgr45c8b853rPJxUZouCr-PNVBPMKqhAoI5ayBAT2FK4LNPkaH0FPfYjKvLzPEx5PLMSfSPAnTvd35V8ZledSnmGFiA9wdthW1G8fv3xJlCdhykhy4FroyyRlTM22rZQunemV2VUeJcObjhyXopM_BhAgxmihC8HB5aSvilhfZUpluR9j20524dId=w1430-h1412?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-08',
  tag1: '#geofencing',
  tag2: '#rtls',
  tag3: '#dinhvivitri',
  tag4: '#theodoivitri',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Trong kỷ nguyên số hóa, doanh nghiệp không chỉ thu hút khách hàng qua mạng mà còn muốn tương tác hiệu quả ngay tại vị trí thực tế của họ. Geofencing – hay hàng rào địa lý ảo là công nghệ giúp doanh nghiệp gửi thông điệp, ưu đãi tức thì khi khách hàng bước vào, ra hoặc di chuyển trong khu vực địa lý nhất định. Bài viết này sẽ giải thích rõ Geofencing là gì? Có thể mang lại lợi ích gì cho doanh nghiệp.',
      dot: ''
    },
    {
      head: '1. Geofencing là gì?',
      subHead: '',
      desc: 'Geofencing là kỹ thuật sử dụng GPS, Wi-Fi, Bluetooth hoặc công nghệ định vị khác để xác định hoặc giới hạn khu vực cụ thể, thiết lập “hàng rào” ảo quanh một vùng địa lý (cửa hàng, sân bay, khu đô thị). Khi thiết bị di động của người dùng có app hoặc quyền theo dõi địa lý, hệ thống sẽ nhận diện sự kiện “vào”, “ra” hoặc “di chuyển trong” khu vực đó và kích hoạt hành động (thông báo, gửi coupon, thu thập dữ liệu).',
      dot: ''
    },
    {
      head: '2. Cơ chế hoạt động của Geofencing',
      subHead: '',
      desc: '• Xác định vùng địa lý: Định nghĩa toạ độ tâm và bán kính (ví dụ: 100–500 m).\n\n• Đăng ký sự kiện: Ứng dụng mobile của doanh nghiệp cấp quyền truy cập vị trí cho thiết bị.\n\n• Giám sát liên tục: SDK hoặc service nền (background service) theo dõi tọa độ của thiết bị.\n\n• Kích hoạt hành động: Khi thiết bị thỏa điều kiện (vào/ra/qua vùng rào), hệ thống gửi push notification, email hoặc trigger chiến dịch marketing.',
      dot: ''
    },
    {
      head: '3. Geofencing có thể mang lại lợi ích gì cho doanh nghiệp?',
      subHead: 'Tăng tương tác và chuyển đổi',
      desc: 'Cá nhân hóa ưu đãi tức thì: Gửi coupon, khuyến mãi ngay khi khách hàng bước vào bán kính của cửa hàng, thúc đẩy mua sắm.\n\nGợi ý dịch vụ: Nhà hàng có thể gửi menu hoặc ưu đãi đồ uống khi thực khách bước vào khu vực lân cận.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Nâng cao hiệu quả marketing',
      desc: 'Giảm phí quảng cáo: Chỉ nhắm đến khách hàng có khả năng đến cửa hàng, thay vì quảng cáo đại trà.\n\nĐo lường hành vi thực tế: Theo dõi tần suất khách ghé qua vùng rào, thời gian dừng, tỉ lệ chuyển đổi.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Cải thiện trải nghiệm khách hàng',
      desc: 'Hướng dẫn địa điểm: App tự động dẫn khách đến quầy thanh toán, khu khuyến mãi hoặc bãi gửi xe.\n\nThông báo an toàn: Trong khu công nghiệp, gửi cảnh báo khi công nhân di chuyển tới khu vực nguy hiểm.',
      dot: ''
    },
    {
      head: '',
      subHead: 'Tối ưu vận hành và logistics',
      desc: 'Quản lý đội xe: Tự động ghi nhận vị trí xuất – nhập kho, cảnh báo trễ hẹn.\n\nGiám sát tài sản: Kiểm soát việc đưa thiết bị, máy móc ra/ vào khu vực quy định.',
      dot: ''
    },
    {
      head: '4. Ứng dụng thực tiễn',
      subHead: '',
      desc: '• Bán lẻ: Gửi mã giảm giá 20% khi khách đến gần cửa hàng.\n\n• Giao hàng: Nhà vận chuyển kích hoạt thông báo “Giao hàng trong 10 phút” khi xe đến gần địa chỉ.\n\n• Khách sạn – Du lịch: Đón khách tự động khi họ đến cổng, check-in nhanh qua app.\n\n• Sự kiện – Triển lãm: Hỗ trợ khách tham quan nhận bản đồ số và thông tin gian hàng khi họ vào khu hội chợ.',
      dot: ''
    },
    {
      head: '5. Lưu ý khi triển khai Geofencing',
      subHead: '',
      desc: '• Quyền riêng tư: Xin phép người dùng và bảo mật dữ liệu vị trí.\n\n• Chọn bán kính hợp lý: Quá rộng sẽ mất cá nhân hóa, quá hẹp dễ bỏ sót.\n\n• Tối ưu pin và dữ liệu: Giám sát nền cần cân bằng giữa độ chính xác và tiêu hao năng lượng.\n\n• Cập nhật nội dung kịp thời: Ưu đãi phải phù hợp ngữ cảnh và còn hiệu lực.',
      dot: ''
    },
    {
      head: '6. Kết luận',
      subHead: '',
      desc: 'Geofencing là công cụ mạnh mẽ giúp doanh nghiệp tiếp cận và tương tác với khách hàng một cách thông minh, cá nhân hóa và tiết kiệm chi phí. Từ bán lẻ, logistics đến tổ chức sự kiện, bất kỳ ai đều có thể tận dụng Geofencing để nâng cao trải nghiệm người dùng và tối ưu vận hành. Đừng chần chờ, hãy bắt đầu xây dựng “hàng rào” địa lý của riêng bạn ngay hôm nay!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
    ],
  },
};
